import { DotsHorizontalIcon, Pencil2Icon, TrashIcon } from '@radix-ui/react-icons';
import { Row } from '@tanstack/react-table';
import { ListMembersResponse } from '@zond/api-interfaces';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from '@zond/ui';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../store';

interface DataTableRowActionsProps {
  row: Row<ListMembersResponse[0]>;
}

export function DataTableRowActions({ row }: DataTableRowActionsProps) {
  const { t } = useTranslation('settings');
  const user = useStore((state) => state.user);
  return (
    <>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="flex h-8 w-8 p-0 data-[state=open]:bg-muted">
            <DotsHorizontalIcon className="h-4 w-4" />
            <span className="sr-only">{t('members.rowActions.openMenu')}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-[160px]">
          <DropdownMenuItem
            onClick={() => {
              // setCurrentRow(row.original)
              // setOpen('edit')
            }}
          >
            {t('common:actions.edit')}
            <DropdownMenuShortcut>
              <Pencil2Icon className="h-4 w-4" />
            </DropdownMenuShortcut>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={() => {
              // setCurrentRow(row.original)
              // setOpen('delete')
            }}
            className="!text-red-500"
          >
            {t('common:actions.delete')}
            <DropdownMenuShortcut>
              <TrashIcon className="h-4 w-4" />
            </DropdownMenuShortcut>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
